import React from 'react';

export const SageLogo = ({size = "60"}) => {
  return (

    <svg
      style={{ marginTop: '5px' }}
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4107_998)">
        <g clip-path="url(#clip1_4107_998)">
          <path
            d="M11.9565 20.696C16.4612 20.696 20.1241 23.8113 20.2084 28.1473C20.2506 29.3679 19.3666 30.0419 18.3981 30.0419C17.4719 30.0419 16.6722 29.3688 16.63 28.2316C16.5878 25.7894 14.5253 23.9791 11.9144 23.9791C9.47217 23.9791 7.62062 25.7051 7.62062 28.0629C7.62062 30.6307 9.34658 31.7679 12.925 33.0729C16.7556 34.4623 20.2506 36.1038 20.2506 40.9872C20.2506 45.2397 16.9244 48.6494 12.2941 48.6494C7.7472 48.6494 4 45.4497 4 41.1138C4 38.4194 5.305 36.5247 6.56781 36.5247C7.66281 36.5247 8.33593 37.2401 8.33593 38.2085C8.33593 39.0504 7.62062 39.4291 7.62062 40.945C7.62062 43.6394 9.80968 45.3654 12.2941 45.3654C14.9041 45.3654 16.63 43.555 16.63 41.366C16.63 38.6716 14.9041 37.5354 11.3256 36.2716C7.32626 34.8419 4 33.115 4 28.3582C4 24.0644 7.45188 20.696 11.9565 20.696Z"
            fill="#00D639"
          />
          <path
            d="M30.3297 48.6503C25.7828 48.6503 21.9944 44.9875 21.9944 40.3563C21.9944 35.5572 25.825 31.9788 30.4563 31.9788C35.424 31.9788 38.918 35.6838 38.918 40.736V46.8822C38.918 47.935 38.0762 48.6503 37.1079 48.6503C36.0973 48.6503 35.2552 47.935 35.2552 46.8822V40.8616C35.2552 37.5353 33.3607 35.2619 30.3719 35.2619C27.7197 35.2619 25.615 37.4931 25.615 40.3563C25.615 43.0085 27.6775 45.2819 30.2884 45.2819C31.2569 45.2819 31.6778 45.0297 32.2675 45.0297C33.0673 45.0297 33.9091 45.7028 33.9091 46.6713C33.9082 47.9763 32.35 48.6503 30.3297 48.6503Z"
            fill="#00D639"
          />
          <path
            d="M49.2915 61.196C44.5761 61.196 40.661 57.8276 40.661 53.4494C40.661 51.9757 41.5028 51.3026 42.4714 51.3026C43.4396 51.3026 44.2394 51.9345 44.2817 53.155C44.3238 55.8916 46.5129 57.9119 49.2495 57.9119C52.1548 57.9119 54.0484 56.0595 54.0484 53.6593C54.0484 50.9228 51.9437 49.7866 48.3653 48.6494C44.1974 47.3022 40.661 45.4497 40.661 40.3141C40.661 35.5984 44.2817 31.9788 48.9963 31.9788C53.7532 31.9788 57.6691 35.4306 57.6691 39.9775C57.6691 42.7563 56.533 44.9031 54.9746 44.9031C53.922 44.9031 53.2066 44.1457 53.2066 43.2194C53.2066 42.251 54.0484 41.83 54.0484 40.1041C54.0484 37.1988 51.7749 35.2628 49.0384 35.2628C46.3862 35.2628 44.2817 37.2841 44.2817 39.9363C44.2817 42.925 46.4285 44.1888 49.9649 45.3672C54.0484 46.7144 57.6691 48.3981 57.6691 53.3238C57.6691 57.744 54.1751 61.196 49.2915 61.196Z"
            fill="#00D639"
          />
          <path
            d="M68.0014 48.6504C63.2857 48.6504 59.413 44.9454 59.413 40.3151C59.413 35.6838 63.1601 31.9798 67.7903 31.9798C72.464 31.9798 76 35.2216 76 39.3476C76 40.9469 74.8639 41.9154 73.0115 41.9154H68.1702C67.2016 41.9154 66.4862 41.2422 66.4862 40.3572C66.4862 39.5154 67.2016 38.8413 68.1702 38.8413H71.7906C72.1273 38.8413 72.3805 38.6726 72.3805 38.336C72.3805 37.1154 70.8224 35.2207 67.9179 35.2207C65.2236 35.2207 63.0346 37.5363 63.0346 40.3151C63.0346 43.136 65.2657 45.3673 68.0443 45.3673C71.2443 45.3673 72.2969 43.4726 73.6019 43.4726C74.6968 43.4726 75.2858 44.1879 75.2858 44.9885C75.2858 45.746 74.7804 46.4201 73.5175 47.2198C72.2529 48.0185 70.3593 48.6504 68.0014 48.6504Z"
            fill="#00D639"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4107_998">
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_4107_998">
          <rect
            width="72"
            height="40.608"
            fill="white"
            transform="translate(4 20.696)"
          />
        </clipPath>
      </defs>
    </svg>);
};